export default __webpack_public_path__ + "static/media/projectx_nameless.103dab6d.webp";